import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {default as SubRubroListado} from '../../components/Rubro/subRubroList'
import { sagaSwapSubRubro, sagaGetSubRubros, saveSubRubro, sagaEliminiarSubrubro, sagaRevertirSubrubro } from '../../reducers/rubrosReducer/actions'
import {rubrosDataSelector} from '../../selectors/rubrosSelector'
import { usuarioSelector } from '../../selectors/sessionSelector'

class SubRubroContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            nombre: "",
            tipoUsuario: null,
            estado: null,
            localidad: "",
            noHabilitados: true,
            noConfirmados: true,
            modalData:{
                openModal: false,
                mensaje: "Está por eliminar un rubro",
                labelModalOk: "Eliminar",
                handleModalOk: ()=>{},
                handleCloseModal: ()=>{},
            },
            usuarioCargado: false
        }
        // busco los datos iniciales
        this.props.sagaGetSubRubros( this.props.match.params.idRubro ,"", false);
    }

    componentDidUpdate = () => {
        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){
                    window.location.hash = '/Pedidos'
                }
            })
        }
    }

    busqueda(){
        this.props.sagaGetSubRubros( this.props.match.params.idRubro ,this.state.nombre, false)
        this.props.saveSubRubro(undefined);
    }

    handleOnSwap = (ids, idRubro) => {
        let payload = {
            ids: ids,
            idRubro: idRubro
        }
        
        this.props.sagaSwapSubRubro(payload)
    }

    render() {
        return <SubRubroListado 
        newURL={"/Subrubros/Edit/"+ this.props.match.params.idRubro+"/0"}
        rubros={this.props.rubros.subrubros}
        rubroNombre={this.props.match.params.nombreRubro}
        mapToItem={(x)=>({
            nombre:x.nombre, 
            habilitado: x.habilitado || x.tipoRol === 1 ,
            confirmado: x.confirmado, 
            activo: x.activo,
            orden: x.orden,
            onClick: (x.activo)?()=>{ this.props.history.push("/Subrubros/Edit/"+ this.props.match.params.idRubro+"/"+x.idSubrubro) }:undefined, 
            opciones:
            [(x.activo)?{nombre:"Editar",handler:()=>{ this.props.history.push("/Subrubros/Edit/"+ this.props.match.params.idRubro+"/"+x.idSubrubro) }}:undefined,
            {nombre:(x.activo)?"Eliminar":"Revertir",handler:()=>{ 
                (x.activo)?
                this.setState(
                {modalData:{
                    openModal: true,
                    mensaje:`Esta por eliminar el subrubro ${x.nombre}`,
                    labelModalOk: "Eliminar",
                    handleModalOk: ()=>{this.props.sagaEliminiarSubrubro(x.idSubrubro); this.setState({modalData:{openModal:false}});},
                    handleCloseModal: ()=>{this.setState({modalData:{openModal:false}})},
                }}):
                this.setState(
                    {modalData:{
                        openModal: true,
                        mensaje:`Esta por reactivar el subrubro ${x.nombre}`,
                        labelModalOk: "Reactivar",
                        handleModalOk: ()=>{this.props.sagaRevertirSubrubro(x.idSubrubro); this.setState({modalData:{openModal:false}});},
                        handleCloseModal: ()=>{this.setState({modalData:{openModal:false}})},
                    }})
             }}],
            imagen: (x.imagen)?x.imagen:require('../../images/default_subrubro.png'),
        })}
        handleOnSwap={this.handleOnSwap}
        handleOnSave={()=>{}}
        handleOnCancel={()=>{this.props.history.goBack()}}
        handleOnSearch={(nombre)=>{
            this.setState({nombre:nombre},()=>{this.busqueda()})
        }}
        canSwap={this.state.nombre === ""}
        {...this.state.modalData}
    />
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        sagaSwapSubRubro, sagaGetSubRubros, saveSubRubro, sagaEliminiarSubrubro, sagaRevertirSubrubro,
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        rubros: rubrosDataSelector(state),
        usuario: usuarioSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SubRubroContainer)